export default {
  setShopListGalleryList (state, payload) {
    let {
      title,
      pics
    } = payload
    state.shopDetailGalleryList.title = title
    state.shopDetailGalleryList.pics = pics
  },
  updateShopDetail (state, payload) {
    state.shopBaseDetail = Object.assign(state.shopBaseDetail, payload)
  },
  updateCurrentShopDetail (state, payload) {
    state.currentShopBaseDetail = Object.values(payload)[0]
  },

  updateBizoppDetail (state, payload) {
    state.bizoppDetail = Object.assign(state.bizoppDetail, payload)
  },
  updateCurrentBizoppDetail (state, payload) {
    state.currentBizoppDetail = Object.values(payload)[0]
  },
  updateBizoppBillAccount (state, payload) {
    state.currentBizoppBillAccount = payload
  },

  updateAllConfig (state, payload) {
    state.allConfig = Object.assign(state.allConfig, payload)
  },
  updateCurrentAllConfig (state, payload) {
    state.currentAllConfig = Object.values(payload)[0]
  },
  updateContractorDetail (state, payload) {
    state.contractorDetail = Object.assign(state.contractorDetail, payload)
  },
  updateCurrentContractorDetail (state, payload) {
    state.currentContractorDetail = Object.values(payload)[0]
  },
  toggleShowDatePick (state, payload) {
    state.showDatePick = payload
  },
  toggleShowPicker (state, payload) {
    state.showPicker = payload
  },
  toggleBackoutApply (state, payload) {
    state.backoutApply = payload
  },
  togglePayVerifyButton (state, payload) {
    state.payVerifyDialog = payload
  },
  clearAllCurrentInfo (state) {
    state.currentAllConfig = {}
    state.currentContractorDetail = {}
    state.currentShopBaseDetail = {}
    state.currentBizoppDetail = {}
  },
  clearCache (state, payload) {
    let obj = {}
    let {
      shopId
    } = payload
    obj[shopId] = {}
    state.contractorDetail = Object.assign(state.contractorDetail, obj)
    state.shopBaseDetail = Object.assign(state.shopBaseDetail, obj)
    state.allConfig = Object.assign(state.allConfig, obj)
    state.bizoppDetail = Object.assign(state.bizoppDetail, obj)
  },
  updateSaleData(state, payload) {
    state.saleData = payload
  },
}
